export enum AccessFolderTabs {
  Open = 'OPEN',
  External = 'EXTERNAL',
  Excessive = 'EXCESSIVE',
  InheritanceIssues = 'INHERITANCE_ISSUES'
}

export enum AccessFoldersTypes {
  Open = 'OPEN',
  Restricted = 'RESTRICTED',
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  Excessive = 'EXCESSIVE',
  Appropriate = 'APPROPRIATE',
  Intact = 'INTACT',
  Broken = 'BROKEN'
}
export enum AccessFoldersReviewStatuses {
  needsReview = 'NEEDS_REVIEW',
  inProgress = 'IN_PROGRESS',
  autoReviewed = 'AUTO_REVIEWED',
  reviewed = 'REVIEWED'
}

export enum AccessFoldersListTabs {
  folders = 'Folders',
  files = 'Files'
}

export const HOME_FOLDER_NAME = '/'
export const FOLDER_PATH_SEPARATOR = '/'
export interface AccessControlDirectoryCounts {
  files: {
    total: number
    needsReview: number
    sensitive: number
  }
  folders: {
    total: number
    needsReview: number
    sensitive: number
  }
}

export interface ReviewStatusItem {
  status: AccessFoldersReviewStatuses
  count: number
}

export interface AccessControlOpenAccessSummaryWidget {
  accessControlDirectoryCounts: AccessControlDirectoryCounts
  accessControlDirectoryByReviewStatus: ReviewStatusItem[]
}
export interface PieChartDataItem {
  key: string
  value: number
  color: string
  onClick?: () => void
}

export const REVIEW_STATUS_COLOR_MAP: Record<AccessFoldersReviewStatuses, string> = {
  [AccessFoldersReviewStatuses.needsReview]: '#FFB024',
  [AccessFoldersReviewStatuses.inProgress]: '#2899E0',
  [AccessFoldersReviewStatuses.autoReviewed]: '#C4E299',
  [AccessFoldersReviewStatuses.reviewed]: '#6BB700'
}

export enum DIRECTORY_LISTING_ACTIONS {
  changeReviewStatus = 'changeReviewStatus'
}

export enum FolderAccessModes {
  Read = 'READ',
  Write = 'WRITE'
}

export enum FolderAccessGroupTypes {
  Security = 'SECURITY',
  Distribution = 'DISTRIBUTION',
  M365 = 'M365'
}

export const EXTERNAL_DEPARTMENT = 'External'

export enum GroupsAndUsersTabs {
  Users = 'USERS',
  Groups = 'GROUPS'
}

export enum UserAccessEmployeeType {
  Employee = 'EMPLOYEE',
  Contractor = 'CONTRACTOR',
  Unknown = 'UNKNOWN'
}

export enum BooleanFilters {
  yes = 'yes',
  no = 'no'
}
